// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2iGG6","buttons":"PendingPaymentAlert_buttons__1EzdF"};